"use client";

import React from "react";
import { Wrench, ShieldCheck, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const reasons = [{
  id: "01",
  title: "Nachhaltig & Ökologisch",
  description: "Reduzieren Sie Ihren ökologischen Fußabdruck massiv durch den Einsatz unserer langlebigen und hochwertigen Mehrwegbecher.",
  icon: ShieldCheck
}, {
  id: "02",
  title: "Weniger Müllaufwand",
  description: "Verabschieden Sie sich von Bergen aus Einwegplastik. Unsere Systeme sorgen für saubere Veranstaltungsorte, reduziertem Reinigungsaufwand und weniger Abfall.",
  icon: Wrench
}, {
  id: "03",
  title: "Regionaler Service",
  description: "Als Kärntner Unternehmen garantieren wir kurze Wege, persönliche Ansprechpartner und eine zuverlässige Logistik vor Ort.",
  icon: Users
}];
export default function WhySellWithUs() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: isCtaVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222978" id="warum-cup4us-wählen" className="dark bg-background text-foreground py-24 md:py-32 relative overflow-hidden border-t border-border/10">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/10 blur-[120px] rounded-full pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div ref={headerRef} className={`text-center mb-20 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold mb-6 tracking-tight">
            Warum Cup4us wählen?
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto font-default">
            Wir bieten Ihnen die perfekte Lösung für nachhaltige Events. Profitieren Sie von unserer Erfahrung und unserem regionalen Fokus in Kärnten.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-8 lg:gap-12 transition-all duration-1000 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {reasons.map((reason, i) => <div key={i} data-index={i} className="relative flex flex-col items-start group">
              {}
              <span className="absolute -top-12 -left-6 text-[10rem] leading-none font-default font-black text-primary/10 select-none z-0 transition-colors duration-500 group-hover:text-primary/20">
                {reason.id}
              </span>
              
              <div className="relative z-10 pt-8 pl-4">
                <div className="mb-8 inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/20 border border-primary/30 backdrop-blur-sm transition-transform duration-500 group-hover:-translate-y-2 group-hover:border-primary/60 group-hover:shadow-lg">
                  <reason.icon className="w-8 h-8 text-primary stroke-[1.5]" />
                </div>
                <h3 className="text-2xl font-default font-semibold mb-4 text-foreground tracking-tight">
                  {reason.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed font-default text-base">
                  {reason.description}
                </p>
              </div>
            </div>)}
        </div>

        <div ref={ctaRef} className={`mt-24 text-center transition-all duration-1000 delay-400 ease-out ${isCtaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Button asChild size="lg" className="h-14 px-10 text-lg font-semibold rounded-full bg-primary text-primary-foreground shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300">
            <Link to="#">Mehr erfahren</Link>
          </Button>
        </div>
      </div>
    </section>;
}